import React, { useMemo } from 'react';
import { useLocation } from 'react-router';
import { useHistory } from 'react-router-dom';

import { SegmentedControl } from 'app/design-system/components/SegmentedControl';
import { useTranslation } from 'app/lang';
import { ROUTE_PATH } from 'app/lib/routing/constants';

import dictionary from './BettingTypeSwitcher.dictionary.json';

import styles from './BettingTypeSwitcher.module.scss';

export const BettingTypeSwitcher = () => {
  const { pathname } = useLocation();
  const history = useHistory();
  const { lang, t } = useTranslation();

  const options = useMemo(
    () => [
      {
        id: 'live',
        value: t(dictionary.liveValue),
        dataTest: 'betting-type-switcher-option-live',
        dataGaEvent: 'leftmenu-live',
      },
      {
        id: 'prematch',
        value: t(dictionary.prematchValue),
        dataTest: 'betting-type-switcher-option-prematch',
        dataGaEvent: 'leftmenu-prematch',
      },
    ],
    [lang],
  );

  const onSelect = (data: typeof options[0]) => {
    if (data.id === 'prematch') {
      return history.push(ROUTE_PATH.PREMATCH);
    }

    return history.push(ROUTE_PATH.LIVE);
  };

  const getSelectedId = (): string => {
    if (pathname.startsWith(ROUTE_PATH.PREMATCH)) {
      return 'prematch';
    }

    if (pathname.startsWith(ROUTE_PATH.LIVE)) {
      return 'live';
    }

    return '';
  };

  return (
    <SegmentedControl options={options}
                      onSelect={onSelect}
                      selectedId={getSelectedId()}
                      className={styles.root} />
  );
};
